import { ref } from '@vue/composition-api'
import SlipTemplateApi from '@/api/v2/utility/settings/SlipTemplate'

export default function useSlipFooterItems() {
  const footerItems = ref([])

  async function fetchFooterItems({
    hallId, tableId, slipType, context,
  }) {
    if (!hallId) {
      footerItems.value = []

      return
    }

    try {
      const params = {
        hall_id: hallId,
        table_id: tableId,
        slip_type: slipType,
        position: 'footer',
      }

      if (context) {
        params.context = context
      }

      const res = await SlipTemplateApi.evaluateSlipTemplate(params)

      footerItems.value = res?.data?.data?.items || []
    } catch {
      footerItems.value = []
    }
  }

  return {
    footerItems,
    fetchFooterItems,
  }
}
